
if(!customElements.get('splide-carousel-component1')) {
    customElements.define(
      'splide-carousel-component1',
      class CarouselComponent extends HTMLElement {
        constructor() {
          super();
          this.slidesMobile = parseFloat(this.dataset.slidesMobile); // Slides to show on mobile
          this.slidesTablet = parseFloat(this.dataset.slidesTablet); // Slides to show on tablet
          this.slidesDesktop = parseFloat(this.dataset.slidesDesktop); // Slides to show on desktop
          this.loopSpeed = parseFloat(this.dataset.loopSpeed); // Loop speed for desktop
          this.loopSpeedMobile = parseFloat(this.dataset.loopSpeedMobile); // Loop speed for mobile
          this.matchMedia = window.matchMedia('(min-width: 990px)');
          this.splideSpeed = this.matchMedia.matches ? this.loopSpeed : this.loopSpeedMobile;
          if (this.dataset.infiniteLoop === 'false') return;
          this.initSwiper(); // Initialize the Splide instance
        }
        initSwiper() {
          this.splide = new Splide(this.querySelector('[id^="Splide--"]'), {
            type: 'loop', // Enable looping
            drag: 'free', // Enable free drag
            focus: 'center', // Center focus for active slide
            arrows: false, // Disable navigation arrows
            pagination: false, // Disable pagination
            perPage: this.slidesDesktop, // Default slides per view on desktop
            gap: '35px',
            autoScroll: {
              speed: this.splideSpeed, // Auto-scroll speed
              autoStart: true, // Autoscroll starts manually in the animation frame function
              pauseOnHover: true, // Do not pause on hover
              pauseOnFocus: false, // Do not pause on focus
            },
            // Responsive breakpoints for different screen sizes
            breakpoints: {
              749: { perPage: this.slidesMobile, gap: '11px' }, // Mobile slides per view
              989: { perPage: this.slidesTablet } // Tablet slides per view
            },
          }).mount(window.splide.Extensions);
         
        }
        }
    )
  }